<template>
  <section id="main-content">
    <h1 v-if="currentSubsModel == 'onhb'">Quem é você?</h1>
    <h1 v-if="currentSubsModel == 'preonhb'">Qual a modalidade de participação?</h1>
    <ul v-if="currentSubsModel == 'onhb'" id="profile-path-selection">
      <li>
<!--        <img src="@/assets/static/img/profile1-estudante.jpg" />-->
        <p>&nbsp;</p>
        <p>Sou um estudante que vai inscrever a sua própria equipe.</p>
        <button :disabled="!subsStillGoing" class="btn-main-action" @click="startNewSubscription('student')">Sou estudante</button>
      </li>
      <li>
<!--        <img src="@/assets/static/img/profile2-professor.jpg" />-->
        <p>&nbsp;</p>
        <p>Sou um(a) professor(a) que vai inscrever uma ou mais equipes pelas quais serei responsável.</p>
        <button :disabled="!subsStillGoing" class="btn-main-action" @click="startNewSubscription('teacher')">Sou professor(a)</button>
      </li>
      <li>
<!--        <img src="@/assets/static/img/profile3-funcionario.jpg" />-->
        <p>&nbsp;</p>
        <p>Não sou professor(a) responsável, mas vou inscrever uma ou mais equipes para a escola em que trabalho.</p>
        <button :disabled="!subsStillGoing" class="btn-main-action" @click="startNewSubscription('wildcard')">Sou funcionário(a)</button>
      </li>
    </ul>
    <ul v-if="currentSubsModel == 'preonhb'" id="profile-path-selection">
      <li>
        <img src="@/assets/static/img/individual.jpg" />
        <p>Quero participar sozinho, minha equipe sou eu mesmo! </p>
        <button :disabled="!subsStillGoing"  class="btn-main-action" @click="startNewSubscription('pre_individual')">Individual</button>
      </li>
      <li>
        <img src="@/assets/static/img/domicilio.jpg" />
        <p>O pessoal aqui de casa vai participar e vamos discutir juntos as questões, mas eu vou ser o responsável pela equipe. Nossa equipe é nossa casa! </p>
        <button :disabled="!subsStillGoing" class="btn-main-action" @click="startNewSubscription('pre_residencia')">Domicílio</button>
      </li>
      <li>
        <img src="@/assets/static/img/coletiva.jpg" />
        <p>Eu e meus amigos vamos formar uma equipe e discutir as questões virtualmente. Somos de 2 a 5 pessoas e todos vão ter acesso à prova. </p>
        <button :disabled="!subsStillGoing" class="btn-main-action" @click="startNewSubscription('pre_zapzap')">Zap-zap</button>
      </li>
    </ul>
  </section>
</template>

<script>
//import {mapActions} from 'vuex';

import store from "../../store";
import router from "../../router";
import {mapGetters} from "vuex";

export default {
  name: "StepNew",
  computed: {
    ...mapGetters([
      'currentSubsStep',
      'currentSubsModel',
      'subsStillGoing'
    ])
  },
  methods: {
    startNewSubscription: function(modality) {
      store.dispatch("startNewSubscription", modality).then(function() {
        if (modality == 'student' || modality == 'teacher' || modality == 'wildcard') {
          router.push({
            name: "nothingButFlowers",
            params: {
              subsSlug: store.state.Subscription.subscription_slug,
              step: "institution"
            }
          });
        }
        else {
          router.push({
            name: "nothingButFlowers",
            params: {
              subsSlug: store.state.Subscription.subscription_slug,
              step: "terms_and_conditions"
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/static/css/_mixins.scss";
@import "@/assets/static/css/_definitions.scss";

@mixin over-extended-image($p: 1) {
  position: relative;
  left: -1 * pad($p);
  top: -1 * pad($p);
  margin-bottom: -1 * pad($p);
  max-width: unset;
  width: calc(100% + #{2 * pad($p)});
}

#profile-path-selection {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  @include respond-above(xl) {
    grid-gap: pad(1);
  }
  @include respond-between(lg, xl) {
    grid-gap: pad(0);
  }
  @include respond-between(md, lg) {
    grid-gap: pad(-1);
  }
  @include respond-below(md) {
    grid-template-columns: 1fr;
    grid-gap: pad(-1);
  }
  margin: pad(0) 0 0;
  align-self: stretch;
  li {
    @extend .white-box;
    display: grid;
    grid-gap: pad(1);
    grid-template-columns: auto;
    grid-template-rows: min-content auto min-content;

    img {
      @include respond-above(md) {
        @include over-extended-image(1);
      }
      @include respond-below(sm) {
        @include over-extended-image(0);
      }
    }

    p {
      @include fs(1);
      @extend .hyphenator;
    }

    @include respond-between(sm, md) {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr max-content;
      grid-gap: unset;
      padding: 0;
      img {
        grid-column: 1;
        grid-row: 1 / -1;
        width: 100%;
        object-fit: contain;
        align-self: stretch;
      }
      p {
        padding: pad(0);
        grid-column: 2;
        grid-row: 1;
      }
      button {
        margin: pad(0);
        grid-column: 2;
        grid-row: 2;
      }
    }
  }
}
h1 {
}
</style>